import script from "./ServerLogsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerLogsTab.vue?vue&type=script&setup=true&lang=js"

import "./ServerLogsTab.vue?vue&type=style&index=0&id=75bc3a81&lang=scss"

const __exports__ = script;

export default __exports__